import { useEffect, useState } from "react";
import { cachedGet } from "@/lib/api";

// Impostazioni dell'azienda corrente (nome, logo…); si ricarica dopo il salvataggio.
export const useSettings = () => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    const load = () => cachedGet("/settings").then((r) => setSettings(r.data)).catch(() => {});
    load();
    window.addEventListener("settings-updated", load);
    return () => window.removeEventListener("settings-updated", load);
  }, []);
  return settings;
};
